import type { ReportingGroupType } from "@validereinc/domain";

export const sortReportingGroupsByPriority = (groups: ReportingGroupType[]) =>
  groups
    ?.slice()
    .sort((a, b) =>
      a.priority > b.priority ? -1 : a.priority < b.priority ? 1 : 0
    );
